/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_Preview_HelpInputs */



/**
* | output |
* | --- |
* | "Update the static text preview with an animated preview to help when recording." |
*
* @param {Options_Adr_Enable_Preview_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_preview_help = /** @type {((inputs?: Options_Adr_Enable_Preview_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_Preview_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer l'aperçu statique par un aperçu animé pour aider lors de l'enregistrement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen Sie die statische Textvorschau durch eine animierte Vorschau, um die Aufnahme zu erleichtern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna l'anteprima del testo statico con un'anteprima animata per facilitare la registrazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замените статический текстовый предварительный просмотр на анимированный, чтобы упростить запись.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualice la vista previa de texto estático con una vista previa animada para ayudar durante la grabación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将静态文本预览更新为动画预览，以便在录制时提供帮助。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録画時に役立つように、静的テキスト プレビューをアニメーション プレビューに更新します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग के दौरान सहायता के लिए स्टैटिक टेक्स्ट प्रीव्यू को एनिमेटेड प्रीव्यू से अपडेट करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualize a pré-visualização de texto estático com uma pré-visualização animada para auxiliar durante a gravação.")
	return /** @type {LocalizedString} */ ("Update the static text preview with an animated preview to help when recording.")
});